import * as React from 'react';
import { Route } from 'react-router-dom';

import OrganisationsList from '../components/OrganisationsList';
import OrganisationDetailView from '../components/OrgnisationDetailView';

export default () => (
    <div style={styles.root}>
        <Route path="/organisations" component={OrganisationsList} />
        <Route path="/organisation/:id" component={OrganisationDetailView} />
    </div>
);

const styles = {
    root: {
    } as React.CSSProperties,
};



// WEBPACK FOOTER //
// ./src/screens/AppNavigation.tsx